// extracted by mini-css-extract-plugin
export var actions = "_mp-g";
export var benefitCard = "_mp-b";
export var benefitIcon = "_mp-d";
export var benefitLabel = "_mp-f";
export var benefits = "_mp-a";
export var benefitsSection = "_mp-8";
export var bodyText = "_mp-7";
export var closeButton = "_mp-2";
export var content = "_mp-3";
export var eyebrow = "_mp-4";
export var heading = "_mp-5";
export var image = "_mp-i";
export var imagePanel = "_mp-h";
export var modal = "_mp-0";
export var offerCard = "_mp-c";
export var offerIcon = "_mp-e";
export var sectionLabel = "_mp-9";
export var shell = "_mp-1";
export var title = "_mp-6";